import React from "react";
import PropTypes from "prop-types";
import "../../styles/ListItem.scss";
const ListItem = ({ itemKey, itemValue }) => {

    const displayData = () => {
        return (
            <React.Fragment>
                <p className="text-capitalize list-item-key">{itemKey && itemKey}</p>
                <b className="list-item-text">{itemValue && itemValue}</b>
            </React.Fragment>
        )
    }
    return (
        <React.Fragment>
            {displayData()}
        </React.Fragment >
    )
};

ListItem.propTypes = {
    itemKey: PropTypes.string,
    itemValue: PropTypes.string
}

export default ListItem;